import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { SearchBarComponent } from "../search-bar/search-bar.component";
import { MapStateService } from "src/services/map/map-state.service";
import { RightSidebarService } from "src/services/right-sidebar.service";
import { EvSidebarComponent } from "../ev-sidebar/ev-sidebar.component";
import { LayoutModule, BreakpointObserver } from "@angular/cdk/layout";
import { LeftSidebarService } from "src/services/left-sidebar.service";

@Component({
    selector: "ev-salesmap-layout",
    imports: [CommonModule, SearchBarComponent, EvSidebarComponent, LayoutModule],
    templateUrl: "./ev-salesmap-layout.component.html",
    styleUrl: "./ev-salesmap-layout.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EvSalesmapLayoutComponent {
    private readonly rightSidebarService = inject(RightSidebarService);
    rightSidebarVisible = this.rightSidebarService.isOpen;
    leftSidebarVisible = inject(LeftSidebarService).isOpen;
    leftSidebarService = inject(LeftSidebarService);
    rightSidebarTopPosition = 0;
    private readonly mapStateService = inject(MapStateService);

    constructor(public breakpointObserver: BreakpointObserver) {}

    ngOnInit() {
        this.breakpointObserver.observe(["(max-width: 765px)"]).subscribe((result) => {
            if (result.matches) {
                this.rightSidebarTopPosition = 48;
            } else {
                this.rightSidebarTopPosition = 0;
            }
        });
    }

    ngOnDestroy() {
        this.rightSidebarService.closeSidebar();
    }
}
